import React, { useEffect } from 'react';
import Navigation from '../components/navigation';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { CSSTransition,TransitionGroup, SwitchTransition } from "react-transition-group";
import {BrowserRouter as Router,Route,Switch,withRouter} from 'react-router-dom';

import { fetchCategories,setCurrentCategory,setSubCategoriesStatus } from '../store/categories/functions';
import { CategoriesState } from '../store/categories/types';
import { AppState } from '../store';
import { setPathName, updateToken, logOut, setMenuStatus } from '../store/base/functions';

import TopBar from './../components/main/topBar';
import Footer from './../components/main/footer';

import Dashboard from './../components/pages/dashboard';
import Category from '../components/pages/category';
import UserProfile from '../components/pages/profile';
import FormsList from '../components/pages/formsList';
import FormItem from '../components/pages/formItem';
import FormItemEdit from '../components/pages/formItemEdit';
import FormItemNew from '../components/pages/formItemNew';

import PostItem from '../components/pages/postItem';
import PostItemEdit from '../components/pages/postItemEdit';
import labEdit from '../components/pages/labEdit';
import usersList from '../components/pages/usersList';
import NewUser from '../components/pages/newUser';
import Hieararchy from '../components/pages/hierarchy';
import { CONSTS } from '../components/elements/_constants';

import IMGCircles from '../static/img/circles.svg';
import EditUser from '../components/pages/editUser';
import commodityList from '../components/pages/store/commodityList';
import NewCommodity from '../components/pages/store/newCommidity.js';
import NewTransaction from '../components/pages/store/newTransaction.js';

type AppProps = {
  onFetchCategories: Function;
  onSetCurrentCategoryId: Function;
  onToggleSubCategories: Function;
  onUpdateToken: Function;
  onSetMenuStatus: Function,
  onLogOut: Function,
  categories: CategoriesState;
  currentCategoryId: number,
  isLoading: boolean,

  match?: any,
  location?: any,
  onSetCurrentPath: Function
}

const App = (props:AppProps)=>{

  useEffect(() => {
    props.onUpdateToken();
    let token = localStorage.getItem('token');
    if(!token) {
      props.onLogOut();
      return;
    } else if(token.length == 0){
      props.onLogOut();
      return;
    }
    if (Object.keys(props.categories.items).length == 0) {
      props.onFetchCategories();
    }
  }, [])

  useEffect(() => {
    props.onSetCurrentPath(props.location.pathname);
    props.onSetMenuStatus(false);
    if(!props.location.pathname.includes("categories")) {
      props.onSetCurrentCategoryId(0);
    }
  }, [props.location.pathname])

  useEffect(() => {
    if(props.currentCategoryId == 0) {
      props.onToggleSubCategories(false);
    } else {
      props.onToggleSubCategories(true);
    }
  }, [props.currentCategoryId])

  return(
    <StyledMain>
      {props.isLoading &&
        <SwitchTransition>
          <CSSTransition
            key={""+props.isLoading}
            classNames="fade"
            timeout={300}
          >
            <div style={{background:'rgba(114,121,135,.3)',zIndex:11111111,width:'100vw',height:'100vh',position: 'fixed',top:0,left:0,bottom:0,right:0,display:'flex',alignItems: 'center',alignContent:'center',justifyContent:'center'}}>
              <img src={IMGCircles} width="55px" height="auto"/>
            </div>
          </CSSTransition>
        </SwitchTransition>
      }
        <Navigation currentCategoryId={props.currentCategoryId}/>

        <div className="_base-style">
            <TopBar/>

            <div className="_base-frame">
              <TransitionGroup>
                <CSSTransition
                  key={props.location && props.location.key}
                  classNames="fade"
                  timeout={300}
                >
                    <Section>
                      <Switch location={props.location}>
                        <Route path="/" component={Dashboard} exact/>
                        <Route path="/profile" component={UserProfile} exact/>
                        <Route path="/laboratory" component={labEdit} exact/>
                        <Route path="/charts/:id" component={Hieararchy} exact/>
                        <Route path="/users" component={usersList} exact/>
                        <Route path="/users/new" component={NewUser} exact/>
                        <Route path="/users/:id" component={EditUser} exact/>
                        <Route path="/store" component={commodityList} exact/>
                        <Route path="/store/transactions/new" component={NewTransaction} exact/>
                        <Route path="/store/transactions/:id/edit" component={(props:any) => <NewTransaction isUpdate={true} {...props} />} exact/>
                        <Route path="/commodities/new" component={NewCommodity} exact/>
                        <Route path="/commodities/:id/edit" component={(props:any) => <NewCommodity isUpdate={true} {...props} />} exact/>
                        <Route path="/categories/:id" component={Category} exact/>
                        <Route path="/categories/:id/forms/:formId" component={FormsList} exact/>
                        <Route path="/categories/:id/forms/:formId/new" component={FormItemNew} exact/>
                        <Route path="/categories/:id/forms/:formId/items/:itemId" component={FormItem} exact/>
                        <Route path="/categories/:id/forms/:formId/items/:itemId/edit" component={FormItemEdit} exact/>
                        <Route path="/categories/:id/posts/:postId" component={PostItem} exact/>
                        <Route path="/categories/:id/posts/:postId/edit" component={PostItemEdit} exact/>
                      </Switch>
                      <Footer/>

                    </Section>
                  </CSSTransition>
                </TransitionGroup>
            </div>


        </div>
    </StyledMain>
  )
}


const Section = styled.div`
  box-sizing: border-box;
  padding: 29px;
  @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
    padding: 0;
  }
  @media only print{
    padding: 0;
  }
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  /* height: auto; */
`
const StyledMain = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: stretch;
    align-content: flex-start;
    ._base-style {
      width: calc(100vw - 300px);
      @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
        width: calc(100vw);
      }
      height: 100vh;
      overflow: hidden;
      @media print {
        overflow: visible;
        visibility: visible;
        position: absolute;
        left: 0;
        right: 0;
        top: -60px;
        height: auto;
        width: auto;
      }
      ._base-frame {
        position: relative;
        height: calc(100vh - 60px);
        overflow-y: auto;
        overflow-x: hidden;
        @media print {
          *{
            visibility: visible;
          }
          height: auto;
          overflow: visible;
        }
        /* width */
        ::-webkit-scrollbar {
            width: 10px;
        }
        /* Track */
        ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: ${CONSTS.colors.primaryLight};
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: ${CONSTS.colors.greyDark};
        }
      }
    }
`

const mapStateToProps = (state: AppState) => ({
  categories: state.categories,
  currentCategoryId: state.categories.currentCategoryId,
  isLoading: state.categories.isFetching || state.forms.isFetching || state.posts.isFetching
});

const mapDispatchToProps = (dispatch:any) => {
  return {
    onFetchCategories       : ()                =>{
      dispatch(fetchCategories());
    },
    onSetCurrentCategoryId  : (id: number)      =>{
      dispatch(setCurrentCategory(id));
    },
    onToggleSubCategories   : (open: boolean)   =>{
      dispatch(setSubCategoriesStatus(open));
    },
    onSetMenuStatus: (isOpen: boolean)=>{
        dispatch(setMenuStatus(isOpen));
    },
    onSetCurrentPath        : (path: string)    =>{
        dispatch(setPathName(path));
    },
    onUpdateToken           : ()                =>{
        dispatch(updateToken())
    },
    onLogOut                :()                 =>{
      dispatch(logOut())
    }
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App));